export const CERTIFICATE = 'zeugnisse'
export const INTERLOCKING_TEST = 'eignungstests'
export const WORK_TRIAL = 'schnupperberichte'
export const CV = 'lebenslauf'
export const MOTIVATION_LETTER = 'motivationsschreiben'
